import type { User } from "@itaas/core/auth/models/user.model";
import { routes } from "@/router/all_routes";
import {
  canAccessPlatformCommercial,
  canAccessPlatformSettings,
  canAccessPlatformUsers,
  canReadPlatformSchools,
} from "./platform-access";

export interface PlatformMenuItem {
  id: string;
  label: string;
  description: string;
  path: string;
  visible: (user: User | null | undefined) => boolean;
}

export const PLATFORM_MENU_ITEMS: PlatformMenuItem[] = [
  {
    id: "schools",
    label: "Écoles",
    description: "Liste des établissements, setup et sync IAM",
    path: routes.platformSchools,
    visible: canReadPlatformSchools,
  },
  {
    id: "users",
    label: "Utilisateurs & rôles",
    description: "Comptes, invitations et accès modules",
    path: routes.platformUsers,
    visible: canAccessPlatformUsers,
  },
  {
    id: "commercial",
    label: "Commercial",
    description: "Leads PEP — devis, démos et essais",
    path: routes.platformCommercial,
    visible: canAccessPlatformCommercial,
  },
  {
    id: "settings",
    label: "Paramètres",
    description: "Modules licenciés et configuration",
    path: routes.platformSettings,
    visible: canAccessPlatformSettings,
  },
];

export function visiblePlatformMenuItems(user: User | null | undefined): PlatformMenuItem[] {
  return PLATFORM_MENU_ITEMS.filter((item) => item.visible(user));
}
